function importAll (r) {
  r.keys().forEach(r);
}
const context = require.context("simple_stuff", true, /\.js$/)
importAll(context)
